import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Loader2 } from 'lucide-react';

export const LoadingState: React.FC = () => {
  return (
    <div className="w-full min-h-screen">
      <div className="max-w-7xl mx-auto space-y-6 font-manrope px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-center">
          <Link to="/clients">
            <Button variant="ghost" size="sm" className="gap-1">
              <ArrowLeft className="h-4 w-4" /> Back to Clients
            </Button>
          </Link>
        </div>
        <div className="flex items-center justify-center py-20">
          <div className="flex flex-col items-center gap-4">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
            <p className="text-lg font-medium">Loading client details...</p>
          </div>
        </div>
      </div>
    </div>
  );
};
